export const AtlassianCertificationMarkBrand = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.2888 19.9252C16.7888 19.3252 15.9888 19.4252 15.5888 20.1252L7.08882 37.1252C6.78882 37.8252 7.28882 38.6252 7.98882 38.6252H19.7888C20.1888 38.6252 20.4888 38.4252 20.6888 38.0252C23.2888 32.7252 21.6888 24.7252 17.2888 19.9252Z"
      fill="url(#paint0_linear_994_2075)"
    />
    <path
      d="M23.4888 4.525C18.7888 12.025 19.0888 20.325 22.1888 26.625C25.2888 32.925 27.6888 37.625 27.8888 38.025C28.0888 38.425 28.3888 38.625 28.7888 38.625H40.5888C41.3888 38.625 41.7888 37.825 41.4888 37.125C41.4888 37.125 25.5888 5.325 25.1888 4.525C24.8888 3.825 23.8888 3.825 23.4888 4.525Z"
      fill="#0082FF"
    />
    <defs>
      <linearGradient
        id="paint0_linear_994_2075"
        x1="21.9049"
        y1="22.5806"
        x2="12.9499"
        y2="38.0906"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0050D3" />
        <stop offset="0.923" stopColor="#0082FF" />
      </linearGradient>
    </defs>
  </svg>
);
